export function requiresCustoms(values) {
  const from = `${values.ship_from?.country || 'US'}`.trim().toUpperCase();
  const to = `${values.ship_to?.country || ''}`.trim().toUpperCase();
  const state = `${values.ship_to?.state || ''}`.trim().toUpperCase();
  return from !== to
    || (to === 'US' && ['PR', 'AP', 'AA', 'GU', 'AE', 'AS', 'MP'].includes(state));
}

export function declaredCustomsValue(value) {
  return value != null && `${value}`.trim() !== '' && Number(value) === 0 ? 1 : value;
}

export function getContentsWeight(items = []) {
  return items.reduce(
    (total, item) => total + (Number(item.qty) || 0) * (Number(item.weight) || 0),
    0,
  );
}

// Formik's validate callback and the rate button share these checks.
export function getCustomsErrors(values) {
  if (!requiresCustoms(values)) return {};

  const errors = {};
  const packageWeight = Number(values.package?.weight);
  if (!Number.isFinite(packageWeight) || packageWeight <= 0) {
    errors.package = { weight: 'Enter a positive package weight from the scale.' };
  }
  if (!Array.isArray(values.items) || !values.items.length) {
    errors.items = 'Add at least one contents item for international shipping.';
    return errors;
  }

  const itemErrors = values.items.map((item) => {
    const error = {};
    if (typeof item.description !== 'string' || !item.description.trim()) {
      error.description = 'Description is required for international shipping.';
    }
    const value = Number(item.value);
    if (item.value == null || `${item.value}`.trim() === '' || !Number.isFinite(value) || value < 0) {
      error.value = 'Enter a declared value of 0 or more. Zero will be declared as 1.';
    }
    if (!Number.isFinite(Number(item.qty)) || Number(item.qty) <= 0) {
      error.qty = 'Enter a quantity greater than 0.';
    }
    if (!Number.isFinite(Number(item.weight)) || Number(item.weight) <= 0) {
      error.weight = 'Enter a weight per item greater than 0 lb.';
    }
    return error;
  });
  if (itemErrors.some((error) => Object.keys(error).length)) errors.items = itemErrors;

  if (Number.isFinite(packageWeight) && getContentsWeight(values.items) - packageWeight > 1e-9) {
    errors.customsWeight = 'Total contents weight must be at or below the package weight from the scale.';
  }
  return errors;
}
